<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="CO1 para-style-override-7">contents</p>
</div>
<div>
<p class="Headnote"><a href="#/page05_intro">Introduction</a></p>
<p class="Headnote"> </p>
<p class="Headnote"><a href="#/page06_fashion"><span class="C1 char-style-override-24" xml:lang="en-US">Fashion</span> <span class="C2 char-style-override-25" xml:lang="en-US">Mavens</span></a></p>
<p class="Headnote"> </p>
<p class="Headnote"> </p>
<p class="Headnote"><span href="#/page07_tom" title="Link target outside of Sample"><span class="C1 char-style-override-24" xml:lang="en-US">Tomboys</span></span></p>
<p class="Headnote"> </p>
<p class="Headnote"> </p>
<p class="Headnote"><span href="#/page08_global" title="Link target outside of Sample"><span class="C1 char-style-override-24" xml:lang="en-US">Global</span><span class="C2 char-style-override-25" xml:lang="en-US"> </span><span class="C2 char-style-override-25" xml:lang="en-US">Travelers</span></span></p>
<p class="Headnote"> </p>
<p class="Headnote"> </p>
<p class="Headnote"><span href="#/page09_thrill" title="Link target outside of Sample"><span class="C1 char-style-override-24" xml:lang="en-US">Thrill</span><span class="C1 char-style-override-24" xml:lang="en-US"> </span><span class="C2 char-style-override-25" xml:lang="en-US">Seekers</span></span></p>
<p class="Headnote"> </p>
<p class="Headnote"> </p>
<p class="Headnote"><span href="#/page10_special" title="Link target outside of Sample">Special Techniques</span></p>
<p class="Headnote"><span href="#/page11_abbr" title="Link target outside of Sample">Abbreviations</span></p>
<p class="Headnote"><span href="#/page12_sources" title="Link target outside of Sample">Sources for Supplies</span></p>
<p class="Headnote"><span href="#/page13_biblio" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="Headnote"><span href="#/page14_ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="Headnote"><span href="#/page15_index" title="Link target outside of Sample">Index<span class="indent"></span></span></p>
<p class="Headnote"><span href="#/page16_author" title="Link target outside of Sample">About the Author</span></p>
</div>
<div class="frame-2">
<img alt="PG5" class="frame-5" src="images/PG5_fmt.jpeg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page04_toc.vue?466a69c5